<form class="user-details" [formGroup]="form" (ngSubmit)="saveUser(form)">
  <div class="content">
    <span class="content-header" translate="modal-edit-user_user-details"></span>

    <section class="content-body">
      <mat-form-field appearance="outline">
        <mat-label id="first-name-label" translate="modal-edit-user_first-name"></mat-label>
        <input
          type="text"
          matInput
          id="userFirstName"
          formControlName="userFirstName"
          data-cy="edit-user-form-first-name"
          class="fullstory-ignore form-control"
          aria-labelledby="first-name-label"
          autocomplete="given-name"
          [readonly]="isEnvironmentLTI()"/>
        @if (form.controls.userFirstName.hasError('required')) {
          <mat-error data-cy="edit-user-form-first-name-invalid">{{'common-validation_first-name-required' | translate}}</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label id="last-name-label" translate="modal-edit-user_last-name"></mat-label>
        <input
          type="text"
          matInput
          id="userLastName"
          formControlName="userLastName"
          data-cy="edit-user-form-last-name"
          class="fullstory-ignore form-control"
          aria-labelledby="last-name-label"
          autocomplete="family-name"
          [readonly]="isEnvironmentLTI()"/>
        @if (form.controls.userLastName.hasError('required')) {
          <mat-error data-cy="edit-user-form-last-name-invalid">{{'common-validation_last-name-required' | translate}}</mat-error>
        }
      </mat-form-field>

      @if (currentLanguage) {
        <mat-form-field appearance="outline">
          <mat-label translate="modal-edit-user_language"></mat-label>
          <mat-select
            formControlName="language"
            disableOptionCentering
            panelClass="offsetPanel">
            @for (language of languages; track language) {
              <mat-option
                [value]="language">
                {{ language.name }}
              </mat-option>
            }
          </mat-select>
          <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
        </mat-form-field>
      }

      <div class="group-wrapper email-group">
        <span>
          <mat-form-field class="no-line">
            <mat-label id="email-label" translate="common_email"></mat-label>
            <input
              type="text"
              matInput
              id="userEmail"
              formControlName="userEmail"
              data-cy="edit-user-form-email"
              class="fullstory-ignore form-control"
              aria-labelledby="email-label"
              readonly/>
          </mat-form-field>
        </span>
        @if (!isEnvironmentLTI()) {
          <span class="change-email-btn-container">
            @if (hasAuthProviderGoReact() && !hasSsoProvider()) {
              <button
                class="secondary-btn change-email-btn"
                type="button"
                (click)="changeEmail()"
                translate="modal-edit-user_change-email">
              </button>
            }
          </span>
        }
      </div>

      @if (!isEnvironmentLTI()) {
        @if (hasAuthProviderGoReact()) {
          <div class="group-wrapper password-group">
            <span>
              <mat-form-field class="no-line">
                <mat-label id="password-label" translate="common_password"></mat-label>
                <input
                  type="password"
                  matInput
                  class="fullstory-ignore form-control"
                  aria-labelledby="password-label"
                  value="********"
                  readonly/>
              </mat-form-field>
            </span>
            <span>
              <button
                class="secondary-btn change-password-btn"
                type="button"
                (click)="changePassword()"
                translate="modal-edit-user_change-password">
              </button>
            </span>
          </div>
        }
      }

      @if (!isEnvironmentLTI()) {
        <div class="sso-section">
          @if (hasSsoProvider()) {
            <span class="group-wrapper unlink-group">
              <span class="content-header" translate="sso_sso-details"></span>
              @for (provider of ssoProviders; track provider) {
                <div class="linked-providers">
                  <div class="sso-account-linked" [ngClass]="provider.provider_name">
                    <span>
                      <img class="provider-logo" [src]="provider.open_id_configuration.logo_url" [alt]="provider.open_id_configuration.display_name + ' logo'">
                    </span>
                    <span translate="common_sso-account-linked" [translateParams]="{provider: provider.open_id_configuration.display_name}"></span>
                    @if (!this.masquerade.isMasked()) {
                      <span>
                        <button
                          class="secondary-btn unlink-btn"
                          type="button"
                          (click)="unlinkSsoAccount(provider)"
                          translate="unlink-sso-dialog_unlink">
                        </button>
                      </span>
                    }
                  </div>
                </div>
              }
            </span>
          }
          @if (ssoProviders && !this.masquerade.isMasked()) {
            <div class="group-wrapper link-new-providers">
              <span class="content-header" translate="sso_link-providers"></span>
              <sso-provider-button
                [excludedProviders]="ssoProviders"
                (onLoginWithSso)="connectSsoAccount($event)">
              </sso-provider-button>
            </div>
          }
        </div>
      }
    </section>
  </div>

  @if (shouldShowSaveButton$ | async) {
    <div class="content-footer">
      <button
        [disabled]="isSaving$ | async"
        class="primary-btn submit-btn"
        type="submit"
        translate="common_save-changes">
      </button>
    </div>
  }
</form>
